<template>
  <nav class="nav" v-if="routeLayout.isStore">
    <button class="nav-icon" :class="{ on: isOn(/(\/product)(\?.*)?/g) }" @click="routeTo(`product`, false)">
      <span class="i-home"></span>
      <span class="ttl">{{ $t('tabBar.storeHome') }}</span>
    </button>
    <button class="nav-icon" :class="{ on: isOn(/(\/category)(\?.*)?/g) }" @click="routeTo(`category`, false)">
      <span class="i-category"></span>
      <span class="ttl">{{ $t('tabBar.category') }}</span>
    </button>
    <button class="nav-icon" :class="{ on: isOn(/(\/search)(\?.*)?/g) }" @click="routeTo(`search`, false)">
      <span class="i-search"></span>
      <span class="ttl">{{ $t('tabBar.search') }}</span>
    </button>
    <button class="nav-icon" :class="{ on: isOn(/(\/information)(\?.*)?/g) }" @click="routeTo(`information`, false)">
      <span class="i-star"></span>
      <span class="ttl">{{ $t('tabBar.review') }}</span>
    </button>
  </nav>
</template>
<script>
import { routerViewLocationKey, useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onMounted, onUpdated, ref, toRef, toRefs } from 'vue';

const layoutState = () => {
  const { getters } = useStore();
  const routeLayout = computed(() => {
    return getters['layout/getRouteLayout'];
  });
  return {
    routeLayout
  };
};

export default {
  name: 'the-store',
  computed: {
    routerViewLocationKey() {
      return routerViewLocationKey;
    }
  },
  description: '하단 네비게이션',
  emits: ['height'],
  setup() {
    const { replace, push } = useRouter();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const fnPage = (path) => {
      router.push(path);
    };

    const thisPage = ref('');

    const routeTo = (to, nested = true) => {
      if (!nested) {
        if (route.name === 'MyOrderProductDetail' || route.name === 'SearchProductDetail') {
          const storeNo = route.params.storeNo;
          if (!storeNo) return;

          store.commit('layout/setFromStorePath', route.path);
          const storePath = `/shop/${encodeURIComponent(storeNo)}/${to}`;
          return route.name === 'SearchProductDetail' ? replace(storePath) : push(storePath);
        }

        return push(to);
      } else {
        // const scrollTop = document.getElementById('scrollable').scrollTop;
        // $store.commit('layout/setScrollTop', scrollTop);
        let lastIndex = '';
        let base = '';
        if (/^\/shop\/\d+\/product\/\d+$/.test(path)) {
          lastIndex = path.lastIndexOf('/');
          const beforeLast = path.lastIndexOf('/', lastIndex - 1);
          base = path.substring(0, beforeLast);
        } else {
          lastIndex = path.lastIndexOf('/');
          base = path.substring(0, lastIndex);
        }

        console.log(`${base}/${to}`);
        replace(`${base}/${to}`);
        thisPage.value = to;
      }
    };

    const isOn = (page) => {
      const { fullPath } = useRoute();
      return (fullPath.match(page) ?? []).length > 0;
    };
    return { ...layoutState(), fnPage, isOn, routeTo };
  }
};
</script>

<style scoped></style>
